import { isArray, isString } from 'lodash';

export default function useGetImage({
  imageUrls,
  image,
  preferredImageFormat = 'webp',
  preferredImageScreen = 'fullhd',
}) {
  if (!isArray(imageUrls)) return image;

  const [imageData] = imageUrls;

  if (!imageData || !isArray(imageData.format) || !isArray(imageData.screen) || !isString(imageData.url)) return image;

  const format = imageData.format.includes(preferredImageFormat) ? preferredImageFormat : imageData.format[0];
  const screen = imageData.screen.includes(preferredImageScreen) ? preferredImageScreen : imageData.screen[0];

  return imageData.url.replace('${screen}', screen).replace('${format}', format);
}
